import { LoadPatients } from 'domain/usecases/patient/load-patients'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteLoadPatients implements LoadPatients {
  constructor(private readonly patientRepository: PatientRepository) {}

  load(params: LoadPatients.Params): Promise<LoadPatients.Model> {
    return this.patientRepository.loadPatients(params)
  }
}

export type LoadPatientsModel = LoadPatients.Model
